export function payorGetBranding(send) {
  return (payorId, ...args) =>
    send(
      {
        path: '/v1/payors/{payorId}/branding',
        pathParameters: { payorId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
